<template>
  <div class="common">
    <!-- 标题 -->
    <div class="comment-title">{{title}}</div>
    <!-- 列表 -->
    <div>
      <div class="list flex-center" v-for="(val,key) in list" :key="key">
        <!-- 头像  -->
        <img @click="showUserCard(val)" :src="setAvatar(val.userIcon)" alt=""
             class="icon">
        <!-- 右侧 -->
        <div class="flex1 main">
          <div class="flex-center">
            <div class="flex-center">
              <!--铭牌 -->
              <img v-if="val.nameplateUrl" :src="val.nameplateUrl" class="nameplate"/>
              <!-- 财富和星级，挑大的显示-->
              <div v-if="val.wealthlEvel > 0" class="bg-grade bg-wealth" :class="'wealth' + val.wealthlEvel"></div>
              <!-- 标题-->
              <p class="title ellipsis" :class="{'two':val.nameplateUrl}">{{val.userName}}</p>
            </div>
            <div class="flex1"></div>
            <!-- 点赞 -->
            <div class="praise flex-center" :class="{'active':val.hasLike}" @click="toPraise(val,key)">
              <p class="num">{{val.likeCount}}</p>
              <div class="bg" :class="{'animate':val.showAnimate}"></div>
            </div>
          </div>
          <!-- 时间 -->
          <div class="time-list flex-center">
            <div class="time">{{timeFormate(val.createAt)}}</div>
            <div v-if="isAdmin || val.showDel" class="del" @click="del(val,key)"><span>·</span>删除</div>
            <div class="set-top" v-if="val.isTop">置顶</div>
            <div class="reply" @click="replyComment(val)">回复</div>
          </div>

          <!-- 内容  -->

          <div class="content" @click="toDetails(val)">
            {{val.content}}
          </div>
          <!-- 二级评论 -->
          <div class="second-comment" @click="toDetails(val)" v-if="val.commentCount">
            <div v-for="(val2,key2) in val.childComment" :key="key2">
              <div class="main-content">
                <template v-if="val2.toUserName">
                  <span>{{val2.isMySelf?'我':val2.userName}}</span><span class="span2">回复</span><span>{{currentUserName===val2.toUserName?'我：':val2.toUserName+':'}}</span>
                </template>
                <template v-if="!val2.toUserName">
                  <span>{{val2.isMySelf?'我':val2.userName}}: </span>
                </template>
                {{val2.content}}
              </div>
            </div>
            <p class="more">共有{{val.commentCount}}条回复 ></p>
          </div>
        </div>
      </div>
    </div>
    <loading :isCenter="true" v-show="!canLoad" />
    <p class="no-more-data" v-show="pageOver">到底了~</p>
  </div>
</template>

<script>
  import { remainTime, formatDateObj } from '../../js/tools';
  import { parsingPath } from 'UTILS/utils';
  import { curScheme } from 'CONFIG/config';
  import loading from 'CMT/loading';

  export default {
    props: {
      listName: '',
      title: '',
      list: '',
      isAdmin: false,
      currentUserName: '',
      canLoad: true, // 是否能加载
      pageOver: false // 是否没数据了
    },
    components: {
      loading
    },
    methods: {
      // 设置头像
      setAvatar (val) {
        return val ? parsingPath(val, 0) : this.$defAvatar;
      },
      // 时间格式化
      timeFormate (oldVal) {
        if (!oldVal) return;
        // console.log('formatDateObj',formatDateObj(oldVal * 1000));
        /*
        * 当用户发言时间距离现在不足1分钟时，显示【刚刚】

          当用户发言时间为 1≤发言时间＜60分钟 时，显示【XX分钟前】

          当用户发言时间为 1≤发言时间＜24小时 时，显示【XX小时前】

          当用户发言时间为 1天≤发言时间＜1年 时，显示【X月X日】

          当用户发言时间为 1年≤发言时间 时，显示【XXXX年X月X日】
                  *
        * */
        // 返回的是当时的时间戳，单位是秒
        let newVal = parseInt(new Date().getTime() / 1000) - oldVal;
        if (newVal < 0) return;
        let time = '';
        let obj = {};
        // 以秒为单位 24小时内
        if (newVal < 60 * 60 * 24) {
          time = remainTime(newVal);
          if (newVal < 60) {
            return '刚刚';
          } else if (newVal < 60 * 60) {
            return time.m + '分钟前';
          } else {
            return time.h + '小时前';
          }
        } else {
          // 1天以上
          obj = formatDateObj(oldVal * 1000);
          if (newVal < 60 * 60 * 24 * 365) {
            // console.log('1年内');
            return obj.m + '月' + obj.d + '日';
          } else {
            // console.log('1年以上');
            return obj.y + '年' + obj.m + '月' + obj.d + '日';
          }
        }
      },
      // 点赞
      toPraise (obj) {
        this.$emit('toPraise', obj);
      },
      // 删除
      del (val, key) {
        this.$emit('del', val, key);
      },
      // 用户主页
      toUserPage (val) {
        let scheme = curScheme;
        window.location.href = `${scheme}?dyaction=miwo&playid=${val.userId}`;
      },
      // 回复评论
      replyComment(val){
        this.$emit('replyComment',val)
      },
      // 查看二级评论
      toDetails(val){
        this.$emit('toDetails',val)
      },
      // 显示名片
      showUserCard(val) {
        if(val.userId === 0){
          return;
        }
        jsBridgeClient.getPlayerData(val.userId);
      }
    }
  };

</script>

<style lang="scss" scoped>
  // 评论
  .common {
    .comment-title {
      font-size: 26px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.85);
      line-height: 37px;
      padding: 22px 0 7px 20px;
    }

    // 列表
    .list {
      align-items: flex-start;
      padding-top: 30px;

      .icon {
        width: 80px;
        height: 80px;
        margin: 0 24px 0 30px;
        border-radius: 50%;
      }

      .main {
        font-weight: 400;
        border-bottom: 1px solid rgba(0, 0, 0, .08);
        // 标题
        .title {
          font-size: 30px;
          color: rgba(0, 0, 0, 0.9);
          line-height: 30px;
          margin-bottom: 8px;
          padding-top: 10px;
          width: 380px;
        }

        .two {
          width: 260px;
        }

        // 铭牌
        .nameplate {
          width: 129px;
          height: 30px !important;
          margin-right: 8px;
        }

        // 等级
        .bg-grade {
          margin-right: 8px;
          height: 30px;
          font-size: 0;
          padding-left: 60px;
          background: url(../../static/charm/charm50.png) no-repeat;
          background-repeat: no-repeat;
          background-size: 100% 100%;

          @for $i from 0 through 50 {
            &.charm#{$i} {
              background-image: url(../../static/charm/charm#{$i}.png);
            }
          }
          // 财富
          &.bg-wealth{
            background-image: url(../../static/wealth/wealth40.png) no-repeat;
            @for $i from 0 through 40 {
              &.wealth#{$i} {
                background-image: url(../../static/wealth/wealth#{$i}.png);
              }
            }
          }
        }
      }

      .time-list {
        height: 34px;
        font-size: 24px;
        margin-bottom: 18px;
        // 时间
        .time {
          color: rgba(0, 0, 0, 0.25);
          height: 30px;
          margin-top: 8px;
          box-sizing: border-box;
        }

        // 删除
        .del {
          margin-top: 4px;
          box-sizing: border-box;
          color: rgba(0, 0, 0, 0.6);

          span {
            margin: 0 10px;
          }
        }

        // 置顶
        .set-top {
          margin-top: 2px;
          width: 52px;
          height: 28px;
          border-radius: 4px;
          border: 1px solid rgba(0, 0, 0, 0.4);
          margin-left: 20px;
          font-size: 20px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.4);
          text-align: center;
          line-height: 28px;
          box-sizing: border-box;
        }

        // 回复
        .reply {
          margin-top: 4px;
          width: 66px;
          height: 34px;
          background: rgba(244, 244, 244, 1);
          border-radius: 17px;
          line-height: 34px;
          font-size: 22px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.5);
          text-align: center;
          margin-left: 16px;
        }
      }

      // 内容
      .content {
        font-size: 26px;
        color: rgba(0, 0, 0, 0.65);
        line-height: 37px;
        padding-bottom: 30px;
        padding-right: 80px;
        box-sizing: border-box;
        word-break: break-word;
      }

      //  二级评论
      .second-comment {
        width: 584px;
        background: rgba(244, 244, 244, 1);
        border-radius: 8px;
        padding: 20px 21px 20px 24px;
        font-size: 26px;
        font-weight: 400;
        color: rgba(254, 124, 60, 1);
        line-height: 42px;
        box-sizing: border-box;
        margin-bottom: 30px;

        .main-content {
          font-weight: 300;
          color: rgba(0, 0, 0, 0.65);

          span {
            font-weight: 500;
            color: #000;

            &.span2 {
              font-weight: 300;
              margin-left: 10px;
              margin-right: 10px;
              color: #606060;
            }
          }
        }
      }

      .line {
        border-bottom: 1px solid rgba(0, 0, 0, .08);
      }

      &:nth-last-child(1) {
        .main {
          border-bottom: none;
        }
      }
    }

    // 点赞
    .praise {
      margin-right: 24px;
      height: 34px;
      font-size: 24px;
      color: rgba(138, 138, 138, 1);

      .num {
        margin-right: 7px;
        line-height: 32px;
      }

      .bg {
        background-image: url("../../img/praise-gray.png");
        background-repeat: no-repeat;
        width: 32px;
        height: 32px;
        background-size: 100% 100%;
      }

      &.active {
        color: #FE7C3C;

        .bg {

          background-image: url("../../img/praise.png");

          &.animate {
            animation: praise .5s linear; // 点赞动画
          }
        }
      }
    }
    .no-more-data{
      font-size: 28px;
      text-align: center;
      color: #DFDFDF;
      padding-bottom: 20px;
    }
  }

</style>
